// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1x5JS","messages":"Chat_messages__1hFsg","dateDivider":"Chat_dateDivider__1Hh5J"};